export let qrCodeTableLabels = [
  {
    label: '商品名称',
    value: 'commodityName'
  },
  {
    label: '二维码数量',
    value: 'qrCodeTotal'
  },
  {
    label: '创建时间',
    value: 'created_date'
  }
]

// 二维码详情列表label

export let qrCodeDetailLabels = [
  {
    label: '商品名称',
    value: 'commodityName'
  },
  {
    label: '用户姓名',
    value: 'userName'
  },
  {
    label: '所属区域',
    value: 'district'
  },
  {
    label: '手机号',
    value: 'mobile'
  },
  {
    label: '创建时间',
    value: 'created_date'
  }
]
